import React from "react";

import PropTypes from "prop-types";

import Rating from "../rating";

function ProductReview({ reviewData }) {
  const { customer_name, date, comment, rating } = reviewData;

  return (
    <article>
      <Rating ratingNumber={rating} />
      <div className="mb-[1rem] mt-[1.125rem] max-w-[46.25rem] break-all text-grayDisplay-700">
        {comment}
      </div>
      <small className="block text-[0.875rem] text-grayDisplay-850">
        By<span className="text-tertiary">&nbsp; {customer_name} &nbsp;</span>
        {date}
      </small>
    </article>
  );
}

ProductReview.propTypes = {
  reviewData: PropTypes.shape({
    customer_name: PropTypes.string,
    date: PropTypes.string,
    comment: PropTypes.string,
    rating: PropTypes.number,
  }),
};

export default ProductReview;
